class ModuleSidebar {
  constructor() {
    this._init();
  }

  _init() {
    document.addEventListener('keydown', this._handleKeydown.bind(this));
    const overlay = document.getElementById('overlay');
    if (overlay) {
      overlay.addEventListener('click', this._hideSidebar.bind(this));
    }
  }

  _handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      this._hideSidebar();
    }
  }

  _hideSidebar() {
    const sidebar = document.querySelectorAll('.sidebar');

    if (document.body.classList.contains('sidebar-open')) {
      // Close all sidebar
      sidebar.forEach((sidebar) => {
        if (sidebar.classList.contains('open')) {
          sidebar.classList.remove('open');
          document.body.classList.remove('sidebar-open');
        }
      });
    }
  }
}

export const moduleSidebar = new ModuleSidebar();
